import React, { useEffect, useState } from 'react'
import Banner2 from '../../components/Banner2'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { createProductInquiry } from '../../features/productInquiry'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import MobileNumberInput from '../../components/MobileNumberInput'

const GroupPersonal = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { t } = useTranslation()

  const handleInputChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.company_name?.trim())
      newErrors.company_name = t("validation.company_required");

    if (!formData.industry?.trim())
      newErrors.industry = t("validation.industry_required");

    if (!formData.no_insurer || formData.no_insurer <= 0)
      newErrors.no_insurer = t("validation.required");

    if (!formData.email) {
      newErrors.email = t("validation.email_required");
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = t("validation.email_invalid");
    }

    if (!formData.mobile_number)
      newErrors.mobile_number = t("validation.phone_required");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error(t("validation.please_fix_errors"));
      return;
    }

    try {
      const response = await dispatch(createProductInquiry({
        form_data: formData,
        product_details: JSON.parse(localStorage.getItem('product_details')),
      })).unwrap();

      if (response.success) {
        toast.success(t('success_res'));
        navigate('/');
      }
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      toast.error(t('error_res'));
    }
  };

  return (
    <>
      <Banner2 classList='bg-grey'>
        <Container>
          <Row>
            <Col md={12}>
              <div className='insurance-title'>
                <h3 className='title text-capitalize text-center'>
                  {t('group_personal.description')}
                </h3>
              </div>
            </Col>

            <Col md={3}>
              <div className='policy-box'>
                <div className='icon-image'>
                  <img
                    src={require('../../assets/SVG/1-31.svg').default}
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <p className='title'>
                  {t('group_personal.title')}
                </p>
              </div>
            </Col>

            <Col md={9}>
              <div className='policy-form'>
                <div className='policy-formBox why-us-form'>
                  <Form onSubmit={handleSubmit}>
                    <Row>

                      <Col md={12}>
                        <div className='form-group'>
                          <Form.Control
                            type='text'
                            name='company_name'
                            placeholder={t('group_personal.form.company_name')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.company_name && (
                            <small className="text-danger">
                              {errors.company_name}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type='text'
                            name='industry'
                            placeholder={t('group_personal.form.industry')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.industry && (
                            <small className="text-danger">
                              {errors.industry}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type='number'
                            name='no_insurer'
                            placeholder={t('group_personal.form.no_insurer')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.no_insurer && (
                            <small className="text-danger">
                              {errors.no_insurer}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type='email'
                            name='email'
                            placeholder={t('group_personal.form.email')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.email && (
                            <small className="text-danger">
                              {errors.email}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <MobileNumberInput
                          onChange={({ countryCode, number }) => {
                            handleInputChange("country_code", countryCode);
                            handleInputChange("mobile_number", number);
                          }}
                        />
                        {errors.mobile_number && (
                          <small className="text-danger">
                            {errors.mobile_number}
                          </small>
                        )}
                      </Col>

                      <Col md={12}>
                        <div className='form-submitbtn'>
                          <button type="submit" className="btn h-btn">
                            {t('group_personal.form.confirm')}
                          </button>
                        </div>
                      </Col>

                    </Row>
                  </Form>
                </div>
              </div>
            </Col>

          </Row>
        </Container>
      </Banner2>
    </>
  )
}

export default GroupPersonal